import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _assign from 'lodash/assign'
import { compose } from 'recompose'

const COMPONENT_NAME = 'RouterConnect'

/**
 * Connects page level behaviors for seo and language to child components.
 */
export function connect () {
  return function wrapComponent (WrappedComponent) {
    // eslint-disable-next-line react/prefer-stateless-function
    class RouterConnect extends Component {
      render () {
        const { props, context } = this
        const { history } = context
        if (!WrappedComponent) return null
        const componentProps = _assign({}, props, {
          history,
        })
        return <WrappedComponent {...componentProps} />
      }
    }

    RouterConnect.displayName = `${COMPONENT_NAME}(${getDisplayName(
      WrappedComponent,
    )})`

    RouterConnect.contextTypes = {
      history: PropTypes.object.isRequired,
    }

    return compose()(RouterConnect)
  }
}

export default connect

function getDisplayName (WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
